import React, { useState, useEffect, useRef } from "react";
import "./style.css";

import amcLogo from "../../../../../assets/imgs/amc-domestico/logo_AMC.png";
import pink_lines from "../../../../../assets/imgs/amc-domestico/Estelas_AMC.svg";
import NoCheckIcon from "../../../../../assets/imgs/amc-domestico/NoGen.svg";
import GenIcon from "../../../../../assets/imgs/amc-domestico/gen.svg";
import iconVoice from "../../../../../assets/imgs/amc-domestico/approve-registration/vocear.svg";
import iconReasign from "../../../../../assets/imgs/amc-domestico/approve-registration/reasign.svg";
import iconFinish from "../../../../../assets/imgs/amc-domestico/approve-registration/finish.svg";

import { FaCheck, FaPause } from "react-icons/fa";
import { IoCopy } from "react-icons/io5";
import { IoMdExit } from "react-icons/io";
import { Modal, Button, Table, Form, Spinner } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import {
  addIdArrDisabled,
  finishTurnAlert,
  getDisabledBtnTurn,
  getIdArrDisabled,
  getTurnId,
  setDisabledBtnTurn,
  setTunrId,
  setValidateAwb,
  validateAwb,
  resetTurnState,
  firstItemService
} from "./documenter-service";

function CountdownTimer({
  initialTime,
  setTimeout,
  isPaused,
  onReset,
  setTurnAsing,
  resetDocumenter,
  setBlock,
  setIsTopUser,
}) {
  const [timeLeft, setTimeLeft] = useState(initialTime);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
  };

  const asingTurn = async () => {
    const body = {
      user_id: localStorage.getItem("heavy-load-email"),
      counter_checkout_id: localStorage.getItem("heavy-counterId"),
    };

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/assign_turn`,
        body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (response.data.code === 1) {
        resetTurnState();
        setTurnAsing(response.data.data);
        setTunrId(response.data.data.turn_id);
        setBlock(false);
        if(response.data.data.top_user === 1) {
          setIsTopUser(true);
        } else {
          setIsTopUser(false);
        }
      }
    } catch (error) {
      if (error.response) {
        const { code, message, data } = error.response.data || {};

        if (code === 0 && message === "Ya existe este registro") {
          setTurnAsing(data);
          setTunrId(data.turn_id);
          setBlock(false);
          if(error.response.data.data.top_user === 1) {
            setIsTopUser(true);
          } else {
            setIsTopUser(false);
          }
        } else if (code === -1 && message === "No hay turnos en espera") {
          setTurnAsing({ turn_number: "No hay turnos en espera" });
          setTimeout(() => {
            resetDocumenter();
          }, 5000);
        } else {
          console.error(`Error del servidor: ${message}`);
        }
      } else {
        console.error("Error de red o desconocido:", error);
      }
    }
  };

  useEffect(() => {
    if (initialTime !== timeLeft) {
      setTimeLeft(initialTime); // Sincroniza con el nuevo tiempo
    }
  }, [initialTime]);

  useEffect(() => {
    if (timeLeft <= 0) {
      asingTurn();
      setTimeout(true);
      return;
    }

    if (isPaused) {
      return; // Si está pausado, no hacemos nada
    }

    const intervalId = setInterval(() => {
      setTimeLeft((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft, isPaused]);

  useEffect(() => {
    if (onReset) {
      setTimeLeft(initialTime);
    }
  }, [onReset, initialTime]);

  return (
    <div className="countdown">
      <p>{formatTime(timeLeft)}</p>
    </div>
  );
}

const ModalInformations = ({ id, onClose }) => {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const [error, setError] = useState("");

  const [showJustification, setShowJustification] = useState(false);
  const [isConfirmEnabled, setIsConfirmEnabled] = useState(false);
  const [justificationText, setJustificationText] = useState("");

  const handleCancelClick = () => {
    setShowJustification(true);
    setIsConfirmEnabled(false); // Se habilitará solo si el textarea tiene texto
  };

  const handleAcceptClick = () => {
    setShowJustification(false);
    setIsConfirmEnabled(true); // Se habilita el botón confirmar
  };

  const handleJustificationChange = (e) => {
    setJustificationText(e.target.value);
    setIsConfirmEnabled(e.target.value.trim().length > 0); // Habilitar solo si hay texto
  };

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(true);
  };

  const handleConfirm = async (formData) => {
    const awbValue = getValues("awb");
    setValidateAwb(awbValue);

    let url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/turn/update`;
    let method = "post"; // Método por defecto para la actualización
    let body = {
      id: formData.id,
      awb: formData.awb,
      user_id: localStorage.getItem("heavy-load-email"),
      counter_description: formData.counter_description,
    };

    if (showJustification && justificationText.trim().length > 0) {
      url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/cancel`;
      method = "put"; // Se cambia el método a PUT
      body = {
        id: formData.id,
        description: justificationText,
        user_id: localStorage.getItem("heavy-load-email"),
      };
    }

    try {
      const response = await axios({
        method,
        url,
        data: body,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
        },
      });

      if (response.data.code === 1) {
        firstItemService.setIsFirstItemDone(true);
        if (index < items.length - 1) {
          setIndex(index + 1);
          reset();
          setShowModal(false);
          setShowJustification(false);
          setIsConfirmEnabled(false);
          setJustificationText("");
          addIdArrDisabled(formData.id);
          setTimeout(() => {
            setShowModal(true);
          }, 200);
        } else {
          setShowModal(false);
          setShowJustification(false);
          setIsConfirmEnabled(false);
          setJustificationText("");
          addIdArrDisabled(formData.id);
          onClose();
        }
      } else {
        setError("Error updating the turn. Please try again.");
      }
    } catch (error) {
      console.error("Error updating:", error);
      setError(
        "An error occurred while performing the operation. Please try again."
      );
    }
  };

  const handleClose = () => {
    setShowModal(false);
    setShowJustification(false);
    setIsConfirmEnabled(false);
    setJustificationText("");
    onClose();
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/shipment/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "heavy-load-token"
              )}`,
            },
          }
        );
        setItems(response.data.data.shipment);
        setShowModal(true);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (id) fetchData(); // Solo carga datos si hay un ID
  }, [id]);

  return (
    <div>
      {/* Modal */}
      <Modal
        show={showModal}
        onHide={() => {
          handleClose();
        }}
        centered
        dialogClassName="custom-modal-width-documenter"
      >
        <Modal.Header
          closeButton
          style={{
            backgroundColor: "#00154F",
            color: "#FFFFFF",
            backgroundImage: "none",
            textAlign: "center",
          }}
        >
          <Modal.Title>Información</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit(handleConfirm)}>
          <Modal.Body>
            <Table
              className="documenter-table"
              bordered
              style={{ textAlign: "center" }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      backgroundColor: "#a3a3a3",
                      color: "#FFFFFF",
                      padding: "8px",
                    }}
                  >
                    Nombre Cliente
                  </td>
                  <td colSpan="4">
                    <Form.Control
                      type="text"
                      defaultValue={items.customer_name}
                      disabled
                      style={{
                        border: "none",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor: "#a3a3a3",
                      color: "#FFFFFF",
                      padding: "8px",
                    }}
                  >
                    PK $
                  </td>
                  <td colSpan="4">
                    <Form.Control
                      type="text"
                      defaultValue={items.mount}
                      disabled
                      style={{
                        border: "none",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor: "#a3a3a3",
                      color: "#FFFFFF",
                      padding: "8px",
                    }}
                  >
                    Información del contenedor
                  </td>
                  <td colSpan="4">
                    <Form.Control
                      type="text"
                      defaultValue={items.material}
                      disabled
                      style={{
                        border: "none",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor: "#00154F",
                      color: "#FFFFFF",
                      padding: "8px",
                    }}
                  >
                    No. Guía
                  </td>
                  <td colSpan="4">
                    <Form.Control
                      type="text"
                      defaultValue="139-"
                      style={{
                        color: "#0000e3",
                        fontWeight: "600",
                        border: "none",
                      }}
                      {...register("awb", {
                        required:
                          showJustification &&
                          justificationText.trim().length > 0
                            ? false
                            : "Debes agregar un numero de guía",
                        validate: (value) => {
                          if (
                            !(
                              showJustification &&
                              justificationText.trim().length > 0
                            )
                          ) {
                            return (
                              /^\d{3}-\d{8}$/.test(value) ||
                              "Formato No. Guía invalido"
                            );
                          }
                          return true;
                        },
                      })}
                    />
                    <Form.Control
                      type="hidden"
                      value={items.id}
                      {...register("id", {})}
                    />
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor: "#00154F",
                      color: "#FFFFFF",
                      padding: "15px",
                    }}
                  >
                    Comentarios Inspector
                  </td>
                  <td
                    colSpan="3"
                    className={
                      items.inspection_description ? "td-inspect-comment" : ""
                    }
                  >
                    <p className="inspector-comment">
                      {items.inspection_description}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor: "#00154F",
                      color: "#FFFFFF",
                      padding: "15px",
                    }}
                  >
                    Comentarios Pesaje
                  </td>
                  <td
                    colSpan="3"
                    className={
                      items.weighing_description ? "td-inspect-comment" : ""
                    }
                  >
                    <p className="inspector-comment">
                      {items.weighing_description}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td
                    style={{
                      backgroundColor: "#00154F",
                      color: "#FFFFFF",
                      padding: "10px",
                    }}
                  >
                    Comentarios Documentador
                  </td>
                  <td colSpan="3">
                    <Form.Control
                      as="textarea"
                      name="counter_description"
                      id="counter_description"
                      rows={1}
                      style={{ border: "none" }}
                      {...register("counter_description", {})}
                    />
                  </td>
                </tr>
              </tbody>
            </Table>
            {errors.awb && (
              <span
                style={{
                  color: "red",
                  fontSize: "10px",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                {errors.awb.message}
              </span>
            )}
            {error && <p style={{ color: "red" }}>{error}</p>}
            <div className="accept-container">
              <div className="btns-container">
                <Button
                  onClick={handleCancelClick}
                  style={{
                    borderRadius: "0px",
                    border: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "20px",
                    width: "40%",
                    height: "40px",
                    backgroundColor: "#ed544e",
                    color: "#ffffff",
                    fontWeight: "bold",
                  }}
                >
                  Cancelar
                  <img
                    src={NoCheckIcon}
                    alt="No generar"
                    style={{ width: "20px", height: "20px" }}
                  />
                </Button>
                <Button
                  onClick={handleAcceptClick}
                  style={{
                    borderRadius: "0px",
                    border: "none",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "20px",
                    width: "40%",
                    height: "40px",
                    backgroundColor: "#5cb46f",
                    color: "#ffffff",
                    fontWeight: "bold",
                    textAlign: "center",
                  }}
                >
                  Aceptar
                  <img
                    src={GenIcon}
                    alt="generar"
                    style={{
                      width: "20px",
                      height: "20px",
                    }}
                  />
                </Button>
              </div>
              {showJustification && (
                <div className="justification">
                  <h6>¿Por qué deseas cancelar?</h6>
                  <div className="formGroup">
                    <textarea
                      id="textaread"
                      placeholder=" "
                      className="formInput"
                      value={justificationText}
                      onChange={handleJustificationChange}
                    ></textarea>
                    <label htmlFor="textaread" className="formLabel">
                      Escribe aquí tu justificación
                    </label>
                  </div>
                </div>
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="submit"
              style={{
                backgroundColor: isConfirmEnabled ? "#035cf7" : "#a3a3a3",
                border: "none",
                width: "100%",
                fontWeight: "bold",
              }}
              disabled={!isConfirmEnabled}
            >
              Confirmar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

const Documenter = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [timeout, setTimeout] = useState(false);
  const [resetCounter, setResetCounter] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [showPauseModal, setShowPauseModal] = useState(false);
  const [pauseStartTime, setPauseStartTime] = useState(null);
  const [pauseTimeId, setPauseTimeId] = useState(null);
  const [elapsedPauseTime, setElapsedPauseTime] = useState(0);
  const userName = localStorage.getItem("heavy-load-user");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [time, setTime] = useState(0);
  const [selectedId, setSelectedId] = useState(null); // Estado para manejar el ID seleccionado
  const [turnAsing, setTurnAsing] = useState({}); // Turno asignado cada que el contador llega a 0
  const [block, setBlock] = useState(true);
  const navigate = useNavigate();
  const [disabled, setDisabled] = useState(false);
  const [isTopUser, setIsTopUser] = useState(false);
  const [isFirstItemDone, setIsFirstItemDone] = useState(false);

  const hasRunOnce = useRef(true);

  //vista de mnostrador
  const [isCounterSelected, setIsCounterSelected] = useState(false);
  const [idCounterSelected, setIdCounterSelected] = useState("");
  const [isLoadingCounters, setIsLoadingCounters] = useState(true);
  const [counters, setCounters] = useState([]);
  const [disabledIds, setDisabledIds] = useState([]);

  const convertTimeToSeconds = (time) => {
    const parts = time.split(":").map(Number);

    if (parts.length === 3) {
      // Formato HH:MM:SS
      const [hours, minutes, seconds] = parts;
      return hours * 3600 + minutes * 60 + seconds;
    } else if (parts.length === 2) {
      // Formato MM:SS
      const [minutes, seconds] = parts;
      return minutes * 60 + seconds;
    } else {
      console.error("Formato de tiempo inválido:", time);
      return 0; // Devuelve 0 en caso de error
    }
  };

  const setTimeCounter = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/time/set_timeout`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        const newTime = convertTimeToSeconds(res.data.data.setTimeout);
        setTime(newTime);
      } else {
        console.error("Código inválido en la respuesta:", res.data.code);
      }
    } catch (error) {
      console.error("Error al obtener el tiempo:", error);
      setTime(0);
    }
  };

  const handleFinishTurn = async (id) => {
    try {
      const validAwb = await validateAwb();
      if (!validAwb.status) {
        const result = await Swal.fire({
          icon: "warning",
          title: validAwb.message,
          confirmButtonText: "Ok",
          confirmButtonColor: "#020C41",
          iconColor: "#020C41",
        });

        return;
      }
      if (!(await finishTurnAlert(data))) {
        const result = await Swal.fire({
          icon: "warning",
          title:
            "Todos los embarques deben tener un número de guía antes de continuar.",
          confirmButtonText: "Ok",
          confirmButtonColor: "#020C41",
          iconColor: "#020C41",
        });
        return;
      }
      setBlock(true);

      const response = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/turn_finish/${id}`,
        { user_id: localStorage.getItem("heavy-load-email") },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (response.data.code === 1) {
        setDisabledBtnTurn(false);
        setTurnAsing({});
        setLoading(true);
        setTimeout(false);
        setResetCounter((prev) => !prev);
        setIsPaused(false);
        setValidateAwb("");
        hasRunOnce.current = true;
        setIsFirstItemDone(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handlePausePlay = () => {
    if (isPaused) {
      handlePlay(); // Si está pausado, enviar petición de reanudar
    } else {
      handlePause(); // Si está activo, enviar petición de pausa
    }
  };

  const handlePause = async () => {
    const body = {
      counter_checkout_id: localStorage.getItem("heavy-counterId"),
      user_id: localStorage.getItem("heavy-load-email"),
    };
    try {
      // Realizar la petición a la API al pausar
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/record_time`,
        body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        // Configurar el estado del cronómetro
        setPauseTimeId(res.data?.data?.id);
        setPauseStartTime(Date.now());
        setShowPauseModal(true);
        setIsPaused(true); // Marcar el estado como pausado
      }
    } catch (error) {
      console.error("Error al pausar:", error);
    }
  };

  const handlePlay = async () => {
    const body = {
      id: pauseTimeId,
      counter_checkout_id: localStorage.getItem("heavy-counterId"),
      user_id: localStorage.getItem("heavy-load-email"),
    };
    try {
      // Realizar la petición a la API al reanudar
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/record_time`,
        body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        // Detener el cronómetro
        setPauseTimeId(null);
        setElapsedPauseTime(0);
        setShowPauseModal(false);
        setIsPaused(false); // Marcar el estado como reanudado
      }
    } catch (error) {
      console.error("Error al reanudar:", error);
    }
  };

  const resetDocumenter = () => {
    setTimeout(false);
    setResetCounter((prev) => !prev);
  };

  const callTurn = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/supervisor/turn_scream/${turnAsing.turn_number}`,
        {
          counter_checkout_id: localStorage.getItem("heavy-counterId"),
          turn_id: turnAsing.turn_id,
          user_id: `${localStorage.getItem("heavy-load-email")}`,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        Swal.fire({
          title: "Turno Voceado",
          icon: "success",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "ok",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  const reasingTurn = async () => {
    try {
      const result = await Swal.fire({
        title: "Reasignar Turno",
        text: "¿Estás seguro de reasignar el turno?",
        icon: "warning",
        showDenyButton: true,
        confirmButtonText: "Continuar",
        denyButtonText: `Cancelar`,
        confirmButtonColor: "#020C41",
        iconColor: "#020C41",
      });

      if (result.isDenied) {
        return;
      } else if (result.isDismissed) {
        return;
      }

      setBlock(true);

      const res = await axios.put(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/reasign_turn/${turnAsing.turn_counter_checkouts_id}`,
        { user_id: `${localStorage.getItem("heavy-load-email")}` },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setTurnAsing({});
        setDisabledBtnTurn(false);
        setLoading(true);
        setTimeout(false);
        setResetCounter((prev) => !prev);
        setIsPaused(false);
        setDisabledIds([]);
        hasRunOnce.current = true;
        setIsFirstItemDone(false)
      } else {
        throw new Error(res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getData = async () => {
    setLoading(true);
    const turn_id = await getTurnId();
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/shipments?turn_id=${turn_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setData(res.data.data.shipments);
        if(hasRunOnce.current) {
          await callTurn();
          hasRunOnce.current = false;
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDropdown = () => {
    setOpenDropdown(!openDropdown);
  };

  //para mostrar el modal
  const handleOpenIteration = (id) => {
    setSelectedId(id); // Configura el ID dinámico
  };

  const getCounters = async () => {
    setIsLoadingCounters(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/select_counter_checkout`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setCounters(res.data.data.counter_checkouts);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingCounters(false);
    }
  };

  const selectCounter = (id) => {
    setIdCounterSelected(id);
  };

  const registerCounert = async () => {
    if (!idCounterSelected) {
      Swal.fire({
        title: "Por favor seleccione un mostrador",
        icon: "error",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "ok",
      });
    } else {
      const body = {
        counter_checkout_id: idCounterSelected,
        user_id: localStorage.getItem("heavy-load-email"),
      };

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/select_counter_checkout`,
          body,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(
                "heavy-load-token"
              )}`,
            },
          }
        );
        if (res.data.code === 1) {
          setIsCounterSelected(true);
          localStorage.setItem("heavy-counterId", idCounterSelected);
        }
      } catch (error) {
        Swal.fire({
          title: "El mostrador ya esta asignado a un usuario",
          icon: "warning",
        });
        await getCounters();
        console.error(error);
      }
    }
  };

  const finishCounter = async () => {
    if (!idCounterSelected) return;

    const body = {
      user_id: localStorage.getItem("heavy-load-email"),
    };

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/counter/select_counter_finish/${idCounterSelected}`,
        body,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        setOpenDropdown(false);
        setIdCounterSelected("");
        setIsCounterSelected(false);
        localStorage.removeItem("heavy-counterId");
        getCounters();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const exitCounter = async () => {
    if (!idCounterSelected) return;

    const result = await Swal.fire({
      title: "¿Quieres salir de este mostrador?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí",
      cancelButtonText: "No",
    });

    if (!result.isConfirmed) return;

    await handlePlay();
    await finishCounter();
    window.location.reload();
  };

  const logOut = async () => {
    if (idCounterSelected) {
      await finishCounter(); // Ejecuta directamente la lógica sin preguntar
    }

    await handlePlay();

    const url = `${process.env.REACT_APP_URL_DOMESTIC_BACKEND_HEAVY_LOAD}/user/logout`;
    const body = {
      user_id: localStorage.getItem("heavy-load-email"),
      profile: "3",
    };

    await axios.post(url, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("heavy-load-token")}`,
      },
    });

    localStorage.clear();
    navigate("/amc-domestico/heavy-load/");
  };

  const btnReasignUserTop = () => {
    return (
      <>
        {(turnAsing.number_reassign <= 1 && !isFirstItemDone) ? (
          <button
            className="reasign"
            onClick={reasingTurn}
            disabled={block}
            style={block ? { cursor: "not-allowed" } : {}}
          >
            Reasignar Turno
            <img src={iconReasign} />
          </button>
        ) : null}
      </>
    )
  };

  const btnReasignUser = () => {
    return (
      <>
        {(turnAsing.number_reassign <= 1) ? (
          <button
            className="reasign"
            onClick={reasingTurn}
            disabled={block}
            style={block ? { cursor: "not-allowed" } : {}}
          >
            Reasignar Turno
            <img src={iconReasign} />
          </button>
        ) : null}
      </>
    )
  };

  useEffect(() => {
    const subscription = getDisabledBtnTurn().subscribe(setDisabled);

    return () => {
      subscription.unsubscribe(); // Limpiar la suscripción al desmontar
    };
  }, []);

  useEffect(() => {
    getCounters();
  }, []);

  useEffect(() => {
    function getFormattedDate() {
      const days = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      const months = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      const now = new Date();
      const dayName = days[now.getDay()];
      const day = now.getDate();
      const monthName = months[now.getMonth()];
      const year = now.getFullYear();

      return `${dayName}, ${day} de ${monthName} ${year}`;
    }

    function getFormattedTime() {
      const now = new Date();
      let hours = now.getHours(); // Mantén las horas tal cual están en formato de 24 horas
      const minutes = now.getMinutes().toString().padStart(2, "0");

      // Devuelve el tiempo en formato 24 horas
      return `${hours}:${minutes}`;
    }

    const interval = setInterval(() => {
      setCurrentDate(getFormattedDate());
      setCurrentTime(getFormattedTime());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setTimeCounter();
  }, []);

  useEffect(() => {
    let intervalId;

    if (
      Object.keys(turnAsing).length > 0 &&
      turnAsing.turn_number !== "No hay turnos en espera"
    ) {
      if (hasRunOnce.current) {
        getData();
      }

      if (isTopUser) {
        intervalId = setInterval(() => {
          getData();
        }, 10000);
      } else {
        getData();
      }
    }

    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [turnAsing, isTopUser]);

  useEffect(() => {
    const subscription = firstItemService.isFirstItemDone$.subscribe((value) => {
      setIsFirstItemDone(value);
    });

    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    let interval;

    if (showPauseModal) {
      interval = setInterval(() => {
        setElapsedPauseTime((prevTime) => prevTime + 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [showPauseModal]);

  useEffect(() => {
    const counterId = localStorage.getItem("heavy-counterId");
    if (counterId) {
      setIsCounterSelected(true);
      setIdCounterSelected(counterId);
    }
  }, []);

  useEffect(() => {
    const subscription = getIdArrDisabled().subscribe((ids) => {
      setDisabledIds(ids);
    });

    return () => subscription.unsubscribe();
  }, []);

  return (
    <>
      {isCounterSelected ? (
        <div className="amc-Approved-container">
          <div className="amc-Approved-header">
            <div className="amc-Approved-header-img">
              <div className="logo">
                <img src={amcLogo} alt="Logo" />
              </div>
              <div className="lines_pink">
                <img src={pink_lines} alt="lines" />
              </div>
            </div>
            <div className="amc-Approved-header-hours">
              <div className="hours">
                <span>{currentDate}</span>
                <span>{currentTime}</span>
              </div>
              <div className="user">
                <div className="username">
                  <span>Usuario: {userName}</span>
                </div>
              </div>
            </div>
          </div>
          <div className="amc-Approved-body">
            {/* Registros */}
            <div className="amc-Approved-body-content">
              <div className="title">
                <p>Documentación</p>
              </div>
              <div className="records">
                <table className="records-table">
                  <thead>
                    <tr className="table-header">
                      <th className="table-header-cell"># Turno</th>
                      <th className="table-header-cell"># Embarque</th>
                      <th className="table-header-cell">Quantity id</th>
                      <th className="table-header-cell">Consignatario</th>
                      <th className="table-header-cell"># piezas</th>
                      <th className="table-header-cell">Destino</th>
                      <th className="table-header-cell">Mercancia</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <div className="loading-spinner">
                            <Spinner animation="border" role="status">
                              <span className="visually-hidden">
                                Cargando...
                              </span>
                            </Spinner>
                          </div>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </>
                    ) : (
                      data.map((turno, index) => (
                        <tr key={index}>
                          <td className={`table-cell first-cell`}>
                            {turno.turn_number}
                          </td>
                          <td className={`table-cell middle-cell`}>
                            {turno.tag_number}
                          </td>
                          <td className={`table-cell middle-cell`}>
                            {turno.quantity_id ? turno.quantity_id : ""}
                          </td>
                          <td className={`table-cell middle-cell`}>
                            {turno.consigne_name}
                          </td>
                          <td className={`table-cell middle-cell`}>
                            {turno.pieces}
                          </td>
                          <td className={`table-cell middle-cell`}>
                            {turno.destination}
                          </td>
                          <td className={`table-cell middle-cell`}>
                            {turno.content}
                          </td>
                          <td className="spacing-cell"></td>

                          {!disabledIds.includes(turno.id) && (
                            <td className="info-cell">
                              <div className="info-button-container">
                                <button
                                  className="info-button"
                                  onClick={() => {
                                    handleOpenIteration(turno.id);
                                  }}
                                >
                                  i
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* Contador */}
            <div className="amc-Approved-body-timer">
              <div className="next-turn">
                <h3>{timeout ? "Turno Asignado" : "Siguiente Turno en ..."}</h3>
              </div>
              <div className="time">
                {timeout ? (
                  <p
                    className="turn-asing"
                    style={
                      turnAsing.turn_number === "No hay turnos en espera"
                        ? { fontSize: "2rem" }
                        : {}
                    }
                  >
                    {turnAsing.turn_number || ""}
                  </p>
                ) : (
                  time > 0 && (
                    <CountdownTimer
                      initialTime={time}
                      setTimeout={setTimeout}
                      isPaused={isPaused}
                      onReset={resetCounter}
                      setTurnAsing={setTurnAsing}
                      resetDocumenter={resetDocumenter}
                      setBlock={setBlock}
                      setIsTopUser={setIsTopUser}
                    />
                  )
                )}
              </div>
              {timeout ? (
                <div className="acttions-timeOut">
                  {turnAsing.turn_number === "No hay turnos en espera" ? (
                    <button
                      className="finished"
                      onClick={resetDocumenter}
                      disabled={block}
                      style={block ? { cursor: "not-allowed" } : {}}
                    >
                      Recargar
                    </button>
                  ) : turnAsing.turn_number && turnAsing.turn_number !== "" ? (
                    <>
                      <button
                        className="finished"
                        onClick={() =>
                          handleFinishTurn(turnAsing?.turn_counter_checkouts_id)
                        }
                        disabled={block}
                        style={block ? { cursor: "not-allowed" } : {}}
                      >
                        Finalizar Turno
                        <img src={iconFinish} />
                      </button>

                      {disabledIds.length !== data.length && (
                        <button
                          className="vocear"
                          onClick={callTurn}
                          disabled={block}
                          style={block ? { cursor: "not-allowed" } : {}}
                        >
                          Vocear Turno
                          <img src={iconVoice} />
                        </button>
                      )}
                      {isTopUser ? (
                        btnReasignUserTop()
                      ): (
                        btnReasignUser()
                      )}
                    </>
                  ) : null}
                </div>
              ) : (
                <div className="actions">
                  <div className="play_pause">
                    <button
                      className="btn-play_pause"
                      onClick={handlePausePlay}
                    >
                      <FaPause className="HiMiniPlayPause" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div className="amc-Approved-container">
          <div className="amc-Approved-header">
            <div className="amc-Approved-header-img">
              <div className="logo">
                <img src={amcLogo} alt="Logo" />
              </div>
              <div className="lines_pink">
                <img src={pink_lines} alt="lines" />
              </div>
            </div>
            <div className="amc-Approved-header-hours">
              <div className="hours">
                <span>{currentDate}</span>
                <span>{currentTime}</span>
              </div>
              <div className="user">
                <div className="username">
                  <span>Usuario: {userName}</span>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={handleOpenDropdown}
                  >
                    ▼
                  </span>
                </div>
                {openDropdown && (
                  <div className="dropdownMenu">
                    <ul>
                      <li>
                        <button
                          type="button"
                          className="exit-btn"
                          onClick={logOut}
                        >
                          Cerrar sesión <IoMdExit />
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="amc-Approved-body">
            <div className="amc-Approved-body-counters">
              <div className="title">
                <p>Mostradores Carga Pesada</p>
              </div>
              <div className="counters">
                {isLoadingCounters ? (
                  <div className="loading-spinner">
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Cargando...</span>
                    </Spinner>
                  </div>
                ) : counters.length > 0 ? (
                  counters.map((counter, _index) => (
                    <div
                      key={_index}
                      className={`counter ${
                        idCounterSelected === counter.id ? "active" : ""
                      }`}
                      onClick={() => {
                        selectCounter(counter.id);
                      }}
                    >
                      {counter.name.replace(/.*\s(\d+)$/, "$1")}
                    </div>
                  ))
                ) : (
                  <h1>No hay mostradores disponibles</h1>
                )}
              </div>
            </div>

            <div className="amc-Approved-body-btn">
              <div className="counter-btn-container">
                <button className="next-btn" onClick={registerCounert}>
                  Siguiente &#x276f;
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {selectedId && (
        <ModalInformations
          id={selectedId}
          onClose={() => setSelectedId(null)}
          getData={getData}
        />
      )}

      <Modal
        show={showPauseModal}
        onHide={() => {}}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{
            backgroundImage: "none",
            borderBottom: "none",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <p className="countUp-header">Tiempo transcurrido</p>
        </Modal.Header>
        <Modal.Body
          style={{
            backgroundImage: "none",
            borderBottom: "none",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <div className="countUp">
            <p>
              {Math.floor(elapsedPauseTime / 60)}:
              {String(elapsedPauseTime % 60).padStart(2, "0")}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer
          className="footer-mod"
          style={{
            backgroundImage: "none",
            borderTop: "none",
          }}
        >
          <Button className="btn-resumen" onClick={handlePlay}>
            Reanudar
          </Button>
          <Button className="btn-resumen" onClick={exitCounter}>
            Salir del mostrador
          </Button>
          <Button className="btn-resumen" onClick={logOut}>
            Cerrar sesión
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Documenter;
